import { Card } from '@design/components/card/Card';
import clsx from 'clsx';
import { ReactNode } from 'react';

import styles from './PulseSection.module.scss';

export interface PulseSectionProps {
  title: string;
  children: ReactNode;
  meta?: string;
  flush?: boolean;
  plain?: boolean;
  className?: string;
  dataTestId?: string;
}

export const PulseSection = ({
  title,
  children,
  meta,
  flush = false,
  plain = false,
  className,
  dataTestId,
}: PulseSectionProps) => (
  <section className={clsx(styles.root, className)} data-testid={dataTestId}>
    <div className={styles.header}>
      <h3 className={styles.title} data-pulse-section-title>
        {title}
      </h3>
      {meta && <span className={styles.meta}>{meta}</span>}
    </div>
    {plain ? (
      children
    ) : (
      <Card className={clsx(styles.card, { [styles.flush]: flush })}>
        {children}
      </Card>
    )}
  </section>
);
